var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248 22",
    style: {
      enableBackground: "new 0 0 248 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,2.3c3,0,4.9,1.8,5.1,4.5h2.6C34.9,2.2,31.7,0,27.5,0c-5.9,0-9.8,4.5-10.9,9.6H8.8c-0.6-1.8-2.3-3-4.3-3 C2,6.6,0,8.6,0,11.1c0,2.5,2,4.5,4.5,4.5c2,0,3.6-1.3,4.3-3h7.5c0,0,0,0.1,0,0.1c0,6,3.6,9.2,8.4,9.2c2.9,0,4.8-1.2,6.4-3.2h0.1 v2.8h1.8l2.1-11.1h-8.8l-0.4,2.3H32l-0.1,0.5c-0.7,3.8-2.9,6.6-6.9,6.6c-3.9,0-6-2.9-6-7C19,7.4,21.8,2.3,27.5,2.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6,10.5h-5.9l1.5-7.7h5.4c2.5,0,3.9,1.1,3.9,3.3C52.5,8.9,50.6,10.5,47.6,10.5 M53.3,1.7c-1.1-0.8-2.6-1.2-4.2-1.2h-8 l-4.1,21h2.6l1.7-8.9h5.9c2.8,0,3.6,1.1,3.4,4.2c-0.2,3.4,0.1,4.2,0.4,4.7h2.6v-0.1c-0.4-0.3-0.8-1.1-0.6-4.5 c0.2-3.1-0.2-4.4-2-5.3v-0.1c2.4-0.8,4.1-2.7,4.1-5.6C55.2,4.2,54.5,2.6,53.3,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,19.6c-4.2,0-6.8-2.7-6.8-7.3c0-5.5,2.9-10.1,8.2-10.1c4.3,0,6.8,3,6.8,7.4C75.1,15.2,72.2,19.6,66.8,19.6 M68.3,0 c-6.7,0-11.1,5.6-11.1,12.3c0,6.1,4.1,9.6,9.5,9.6c6.9,0,11-5.5,11-12.3C77.7,3.5,73.7,0,68.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9,14.1c-0.5,1.3-1.4,3.6-1.4,3.6h-0.1c0,0-0.1-2.2-0.2-3.6L94.9,0.5h-2.8l-6,13.6c-0.6,1.4-1.5,3.6-1.5,3.6h-0.1 c0,0-0.1-2.1-0.2-3.6L83.5,0.5h-2.6l1.7,21h2.6l6.6-14.8C92.3,5.3,93,3.4,93,3.4h0.1c0,0,0.1,2,0.2,3.3l1.3,14.8H97l9.3-21h-2.6 L97.9,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,5.1c2.1,0,3.1,1.3,3.1,3.1h6.1c-0.1-2.8-1.1-5.1-3-6.6c-1.4-1.1-3.4-1.6-6.1-1.6c-6.9,0-11.4,5.8-11.4,12.6 c0,6.2,3.9,9.4,9.7,9.4c4.7,0,9.1-2.6,10.1-8.3h-6.2c-0.5,2.2-2,3.3-3.9,3.3c-2.6,0-3.6-2.1-3.6-4.5C112.6,9,114.1,5.1,117.8,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,17.1c-2.7,0-3.8-2-3.8-4.4c0-3.4,1.6-7.7,5.3-7.7c2.7,0,3.7,2,3.7,4.6C142.8,13.1,141.2,17.1,137.6,17.1  M139.3,0.1c-6.9,0-11.5,5.8-11.6,12.6c-0.1,6.3,4.3,9.3,9.8,9.3c6.8,0,11.4-5.6,11.4-12.4C148.9,3.4,145.1,0.1,139.3,0.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.8,0.5 163.5,12.5 163.4,12.5 159.3,0.5 153.2,0.5 149.1,21.5 155,21.5 157.3,9.4 157.4,9.4 161.3,21.5  167.6,21.5 171.7,0.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.4,0.5 172.4,5.6 178.1,5.6 175.1,21.5 181.1,21.5 184.2,5.6 190,5.6 191,0.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.2,9.8h-3.2l0.9-4.6h2.8c1.6,0,2.4,0.8,2.4,2C203,9.1,201.7,9.8,200.2,9.8 M209,6.1c0-3.9-3.4-5.6-7.5-5.6h-8.9 l-4.1,21h6.1l1.4-7.4h2.6c2,0,2.6,1,2.6,2.8c0,1.1-0.1,2.4-0.1,3.2c0,0.5,0.1,1.1,0.2,1.4h6.1v-0.3c-0.2-0.2-0.4-0.6-0.4-1.4 c0-1.1,0-2.6,0-3.5c0-2.3-0.8-3.6-2.4-4.3v-0.1C207.6,10.9,209,9.3,209,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,17.1c-2.7,0-3.8-2-3.8-4.4c0-3.4,1.6-7.7,5.3-7.7c2.7,0,3.7,2,3.7,4.6C225.2,13.1,223.6,17.1,220,17.1 M221.7,0.1 c-6.9,0-11.5,5.8-11.6,12.6c-0.1,6.3,4.3,9.3,9.8,9.3c6.8,0,11.4-5.6,11.4-12.4C231.3,3.4,227.5,0.1,221.7,0.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.5,0.5 231.5,21.5 246.2,21.5 247.2,16.3 238.5,16.3 241.6,0.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2f47aab5203fbb4ab24676f9820a5900.svg";
export { ForwardRef as ReactComponent };